import reducer from "./reducers";

import * as locationIndexOperations from "./operations";
import * as locationIndexActions from "./actions";
import * as locationIndexTypes from "./types";

export { locationIndexOperations, locationIndexActions, locationIndexTypes };

export default reducer;



// WEBPACK FOOTER //
// ./ducks/location-index/index.js